import React, { useState, useHook, useEffect, useRef } from "react";
import Header from "../Header";
import SideBar from "../SideBar";
import Footer from "../Footer";
import Loader from "../Loader";
import { get, post, put, deleteM } from "../../utility/Adapter";
import { withParams } from "../HOC";

import { info, success } from "@pnotify/core";
import "@pnotify/core/dist/PNotify.css";
import "@pnotify/core/dist/BrightTheme.css";
import * as Confirm from "@pnotify/confirm";
import "@pnotify/confirm/dist/PNotifyConfirm.css";
import DataTable, { createTheme } from "react-data-table-component";
import Cookies from "js-cookie";
import {
  Stethoscope,
  UserRound,
  ClipboardCheck,
  GraduationCap,
  XCircle,
  Clipboard,
} from "lucide-react";
import Toast from "../../components/Toast";

function getIconForDegree(degree) {
  switch (degree) {
    case "GNM":
      return Stethoscope;
    case "NURSE":
      return UserRound;
    case "REGISTERED_NURSE":
      return ClipboardCheck;
    case "STUDENT":
      return GraduationCap;
    default:
      return XCircle;
  }
}

const ActiveCandidates = (props) => {
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pending, setPending] = React.useState(true);
  const [totalRows, setTotalRows] = React.useState(0);
  const [paginationPerPage, setPaginationPerPage] = React.useState(25);
  const [candidateType, setCandidateType] = useState('all');
  const [cPage, setPage] = useState(1);
  const [selectedRows, setSelectedRows] = React.useState([]);

  const batchDelete = () => {
    success({
      title: "Confirmation",
      text: "Are you sure you want to delete the selected candidates?",
      modules: new Map([
        [
          Confirm,
          {
            confirm: true,
            buttons: [
              {
                text: "Ok",
                primary: true,
                click: (notice) => {
                  notice.close();
                  setLoading(true);
                  const candidate_ids = selectedRows.map(
                    (row) => row.candidate_id
                  );
                  post("admin/candidates/batch-delete", {
                    candidate_ids: candidate_ids,
                  })
                    .then(async function (response) {
                      _loadCandidates(1);
                      setLoading(false);
                      success({
                        title: "SUCCESS",
                        text: "Successfully deleted selected candidates",
                      });
                    })
                    .catch(function (error) {
                      console.log(error);
                    })
                    .finally(() => {
                      setLoading(false);
                      setSelectedRows([]);
                    });
                },
              },
              {
                text: "Cancel",
                click: (notice) => {
                  notice.close();
                },
              },
            ],
          },
        ],
      ]),
    });
  };

  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null,
  });

  const [candidateTypeCounts, setCandidateTypeCounts] = useState({
    NONE: 0,
    GNM: 0,
    NURSE: 0,
    REGISTERED_NURSE: 0,
    STUDENT: 0,
  });

  const [hoveredPhone, setHoveredPhone] = useState(null);
  const [hoveredEmail, setHoveredEmail] = useState(null);

  const [toastMessage, setToastMessage] = useState(null);
  const [toastType, setToastType] = useState("success");

  useEffect(function () {
    _loadCandidates(1);

    window.$("document").ready(function () {
      window.$("#datePickerRange").datepicker({
        weekStart: 1,
      });
    });

    /*if (props.params.type != undefined) {
            filter('licensed');
        }*/
  }, []);

  const _loginAs = (candidate_id) => {
    // get("admin/candidates/las/" + candidate_id)
    //   .then(async function (response) {
    //     if (response.data.data.token) {
    //       //Cookies.set('hcUser', response.data.data.token, { expires: 1 });
    //       Cookies.set("hcUser", response.data.data.token, {
    //         domain: "dashboard.hireandcare.de",
    //       });
    //       Cookies.set("hcUser", response.data.data.token, {
    //         domain: "hireandcare.de",
    //       });
    //       window.open(process.env.REACT_APP_DASHBOARD_URL, "_blank");
    //     }
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //     setLoading(false);
    //   });

    window.open(
      process.env.REACT_APP_DASHBOARD_URL + "clogin/" + candidate_id + "?token=glsagoW4Rh5APRINOUakKFpc6662d7VkkEcN2jtIr9GTYxK3Hgf90OlRM0rJS70iCPn50ZzEcMjSoe29RtGD1pfuIjleG8JGJcIOThfzPd0LTugP9",
      "_blank"
    );

  };

  const _loadCandidates = (page) => {
    setLoading(true);
    get("admin/candidates/1/" + page)
      .then(async function (response) {
        setCandidates(response.data.data);
        setTotalRows(response.data.totalRows);
        setPaginationPerPage(response.data.paginationPerPage);
        setPending(false);
        setLoading(false);

        setCandidateTypeCounts(response.data.countByCandidateType);

        var table = window.$("#datatableRows").DataTable();
        table.destroy();

        setTimeout(function () {
          var uninitialized = window.$("#datatableRows").filter(function () {
            return !window.$.fn.DataTable.fnIsDataTable(this);
          });

          uninitialized.each(function () {
            window.$(this).dataTable({
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excel",
                  text: "Export Excel",
                  className: "btn btn-light",
                  exportOptions: {
                    columns: "th:not(:last-child)",
                  },
                },
                {
                  extend: "csv",
                  text: "Export Csv",
                  className: "btn btn-light",
                  exportOptions: {
                    columns: "th:not(:last-child)",
                  },
                },
              ],
            });
          });
        }, 100);

        //window.$("#datatableRows").dataTable();
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  var documentStatus = {
    0: "Pending",
    1: "Submitted",
    2: "Waiting Proposal",
    3: "Waiting Payment",
    4: "Translation Progress",
    5: "Translation Under Review",
    6: "Completed",
  };

  var languageLevels = {
    NOT_ENTROLLED: "Not yet enrolled",
    A1_ENTROLLED: "A1 Enrolled",
    A1_COMPLETE: "A2 Complete",
    B1_COMPLETE: "B1 Complete",
    B2_COMPLETE: "B2 Complete",
    C1_COMPLETE: "C1 Complete",
    C2_COMPLETE: "C2 Complete",
  };

  var languageLevelsId = [
    { id: "ANY", val: "Any" },
    { id: "NOT_ENTROLLED", val: "Not yet enrolled" },
    { id: "A1_ENTROLLED", val: "A1 Enrolled" },
    { id: "A1_COMPLETE", val: "A2 Complete" },
    { id: "B1_COMPLETE", val: "B1 Complete" },
    { id: "B2_COMPLETE", val: "B2 Complete" },
    /*{ id: "C1_COMPLETE", val: "C1 Complete" },
    { id: "C2_COMPLETE", val: "C2 Complete" },*/
  ];

  const [selectedLanguageFilter, setSelectedLanguageFilter] = useState(languageLevelsId[0].id);

  const [selectedTypeFilter, setSelectedTypeFilter] = useState("");

  const ExpandedComponent = ({ data }) => <>
      {/* {JSON.stringify(data, null, 2)} 
      <a href={"candidates/upload/hc_documents/" +data.candidate_id} target="_blank" className="dropdown-item">Upload HC Documents</a>
      */}
      <div className="row mt-1" style={{ backgroundColor:"#f5f2f2" }}>
        <div className="col-sm-3 ps-3" style={{ fontSize: 12 }}>
          <b>Name</b><br/>
          {data.candidate_first_name} {data.candidate_last_name} ({data.utm_source})
        </div>
        <div className="col-sm-3 ps-3" style={{ fontSize: 12 }}>
          <b>Email</b><br/>
          {data.candidate_email}
        </div>
        <div className="col-sm-3 ps-3" style={{ fontSize: 12 }}>
          <b>Phone</b><br/>
          {data.candidate_phone}
        </div>
        <div className="col-sm-3 ps-3" style={{ fontSize: 12 }}>
          <b>Nursing Degree</b><br/>
          {data.candidate_degree}
        </div>
        {data.staff_details && data.staff_details.staff_name && (
          <div className="col-sm-3 ps-3" style={{ fontSize: 12 }}>
            <b>Staff Name</b>
            <br />
            {data.staff_details.staff_name}
          </div>
        )}
      </div>

      <div className="row" style={{ backgroundColor:"#f5f2f2" }}>
        <div className="col-sm-2 p-3">
          <a href={"candidates/upload/hc_documents/" +data.candidate_id} target="_blank" style={{fontSize: 12}}>Upload HC Documents</a>
        </div>

        <div className="col-sm-2 p-3">
          <a href="#" onClick={() => _loginAs(data.candidate_id)} style={{fontSize: 12}}>{"Login as " + data.candidate_first_name}</a>
        </div>

        <div className="col-sm-2 p-3">
          <a href={process.env.REACT_APP_DASHBOARD_URL + "download-candidate-resume/" + data.candidate_id} style={{fontSize: 12}} target="_blank">Download Resume</a>
        </div>

        <div className="col-sm-2 p-3">
          <a href={process.env.REACT_APP_DASHBOARD_URL + "download-candidate-employer-resume/" + data.candidate_id} style={{fontSize: 12}} target="_blank">Download Employer Resume</a>
        </div>
        
        <div className="col-sm-2 p-3">
          <a href={"candidate/documents/" + data.candidate_id} style={{fontSize: 12}} target="_blank">Documents</a>
        </div>
      </div>
    </>;

  const columns = [
    {
      name: (
        <input
          type="checkbox"
          onChange={(e) => {
            const isChecked = e.target.checked;
            const newSelectedRows = isChecked ? candidates : [];
            setSelectedRows(newSelectedRows);
          }}
        />
      ),
      selector: (row) => (
        <input
          type="checkbox"
          checked={selectedRows.some(
            (selectedRow) => selectedRow.candidate_id === row.candidate_id
          )}
          onChange={() => {
            const isSelected = selectedRows.some(
              (selectedRow) => selectedRow.candidate_id === row.candidate_id
            );
            if (isSelected) {
              setSelectedRows(
                selectedRows.filter(
                  (selectedRow) => selectedRow.candidate_id !== row.candidate_id
                )
              );
            } else {
              setSelectedRows([...selectedRows, row]);
            }
          }}
        />
      ),
      sortable: false,
    },
    {
      name: "Name",
      selector: (row) => (
        <a
          target="_blank"
          href={"/candidate/" + row.candidate_id}
          style={{ textTransform: "capitalize" }}
          title={row.candidate_first_name + " " + row.candidate_last_name + "(" + row.utm_source + ")"}
        >
          {row.candidate_first_name + " " + row.candidate_last_name }
        </a>
      ),
      sortable: false,
    },
    {
      name: "Aff Id",
      selector: (row) => row.utm_source,
    },
    {
      name: "Email",
      selector: (row) => row.candidate_email,
    },
    {
      name: "Phone",
      selector: (row) => row.candidate_phone,
      sortable: true,
    },
    // {
    //   name: "Nursing License",
    //   selector: (row) => (row.candidate_licence == "Y" ? "Yes" : "No"),
    //   sortable: true,
    // },
    {
      name: "Nursing Degree",
      selector: (row) => row.candidate_degree,
      sortable: true,
    },
    {
      name: "Documents",
      selector: (row) => row.documents_count,
      sortable: true,
    },
    {
      name: "Created",
      selector: (row) => row.created,
      sortable: true,
    },
    {
      name: "",
      selector: (c) => (
        <>
        <a
          title="View Documents"
          style={{ color: "#000" }}
          href={"/candidate/documents/" + c.candidate_id}
          target="_blank"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="acorn-icons acorn-icons-file-text mb-3 d-inline-block text-primary"
          >
            <path d="M6.5 18H13.5C14.9045 18 15.6067 18 16.1111 17.6629C16.3295 17.517 16.517 17.3295 16.6629 17.1111C17 16.6067 17 15.9045 17 14.5V7.44975C17 6.83775 17 6.53175 16.9139 6.24786C16.8759 6.12249 16.8256 6.00117 16.7638 5.88563C16.624 5.62399 16.4076 5.40762 15.9749 4.97487L14.0251 3.02513L14.0251 3.02512C13.5924 2.59238 13.376 2.37601 13.1144 2.23616C12.9988 2.1744 12.8775 2.12415 12.7521 2.08612C12.4682 2 12.1622 2 11.5503 2H6.5C5.09554 2 4.39331 2 3.88886 2.33706C3.67048 2.48298 3.48298 2.67048 3.33706 2.88886C3 3.39331 3 4.09554 3 5.5V14.5C3 15.9045 3 16.6067 3.33706 17.1111C3.48298 17.3295 3.67048 17.517 3.88886 17.6629C4.39331 18 5.09554 18 6.5 18Z"></path>
            <path d="M13 6 7 6M13 10 7 10M13 14 7 14"></path>
          </svg>
        </a>
        <span class="">
                                <a
                                  class="mt-3 ms-4"
                                  href="#"
                                  role="button"
                                  id="dropdownMenuLink"
                                  data-bs-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                  style={{ color: "black" }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    class="acorn-icons acorn-icons-more-vertical d-inline-block"
                                  >
                                    <path d="M10 9C10.5523 9 11 9.44772 11 10V10C11 10.5523 10.5523 11 10 11V11C9.44772 11 9 10.5523 9 10V10C9 9.44772 9.44772 9 10 9V9zM10 2C10.5523 2 11 2.44772 11 3V3C11 3.55228 10.5523 4 10 4V4C9.44772 4 9 3.55228 9 3V3C9 2.44772 9.44772 2 10 2V2zM10 16C10.5523 16 11 16.4477 11 17V17C11 17.5523 10.5523 18 10 18V18C9.44772 18 9 17.5523 9 17V17C9 16.4477 9.44772 16 10 16V16z"></path>
                                  </svg>
                                </a>
                                <div
                                  class="dropdown-menu"
                                  aria-labelledby="dropdownMenuLink"
                                >
                                  <a href={
                                    "/candidates/upload/hc_documents/" +
                                    c.candidate_id
                                  } target="_blank" className="dropdown-item">Upload HC Documents</a>
                                  <a
                                    className="dropdown-item"
                                    href="#"
                                    onClick={() => _loginAs(c.candidate_id)}
                                  >
                                    {"Login as " + c.candidate_first_name}
                                  </a>

                                  <a
                                    class="dropdown-item"
                                    href={
                                      process.env.REACT_APP_DASHBOARD_URL +
                                      "download-candidate-resume/" +
                                      c.candidate_id
                                    }
                                    target="_blank"
                                  >
                                    Download Resume
                                  </a>

                                  <a
                                    class="dropdown-item"
                                    href={
                                      process.env.REACT_APP_DASHBOARD_URL +
                                      "download-candidate-employer-resume/" +
                                      c.candidate_id
                                    }
                                    target="_blank"
                                  >
                                    Download Employer Resume
                                  </a>

                                  <a
                                    class="dropdown-item"
                                    href="javascript:void(0);"
                                    onClick={() => openAssignStaffModal(c.candidate_id)}
                                  >
                                    Assign staff
                                  </a>

                                  <a
                                    class="dropdown-item"
                                    href="javascript:void(0);"
                                    onClick={() => _del(c.candidate_id)}
                                  >
                                    Delete
                                  </a>
                                </div>
                              </span>
        </>
      ),
    },
  ];

  const [assignStaffModal, setAssignStaffModal] = useState(false);
  const [staffs, setStaffs] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [selectedStaffId, setSelectedStaffId] = useState("");

  const openAssignStaffModal = (candidateId) => {
    setAssignStaffModal(true);
    setSelectedCandidate(candidateId);
    setSelectedStaffId(""); // Reset on open
    setLoading(true);
    get("admin/staffs")
      .then((response) => {
        console.log("Staff response:", response.data);
        if (response.data && Array.isArray(response.data.data)) {
          setStaffs(response.data.data);
          response.data.data.forEach((staff) => {
            console.log(`Staff ID: ${staff._id}, Name: ${staff.staff_name}`);
          });
        } else {
          console.error("Unexpected staff data format:", response.data);
          setStaffs([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const assignStaff = () => {
    if (!selectedStaffId) {
      alert("Please select a staff member.");
      return;
    }
    setLoading(true);
    post("admin/candidates/assign-staff", {
      candidate_id: selectedCandidate,
      staff_id: selectedStaffId,
    })
      .then((response) => {
        setLoading(false);
        setAssignStaffModal(false);
        success({
          title: "SUCCESS",
          text: response.data.message || "Staff assigned successfully.",
          modules: new Map([
            [
              Confirm,
              {
                confirm: true,
                buttons: [
                  {
                    text: "Ok",
                    primary: true,
                    click: (notice) => {
                      notice.close();
                    },
                  },
                ],
              },
            ],
          ]),
        });
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const pagination = (page, totalRows) => {

    var date_from = document.getElementById("start_date").value;
    var date_to = document.getElementById("end_date").value;
    setPage(page);

    setLoading(true);
    setPending(true);

    if (date_from != "" && date_to != "") {
      filterByDate(candidateType, page);
    } 
    else {
      _loadCandidates(page);
    }

    
    setLoading(false);
  };

    const filterReset = () => {
    document.getElementById("q").value = "";
    search();
  }

  const search = () => {
    var q = document.getElementById("q").value;

    setPending(true);
    setLoading(true);

    post("admin/candidates/1/search/1", { q: q, type: "search" })
      .then(async function (response) {
        setCandidates(response.data.data);
        setTotalRows(response.data.totalRows);
        setPaginationPerPage(response.data.paginationPerPage);
        setPending(false);
        setLoading(false);

        setCandidateTypeCounts(response.data.countByCandidateType);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const filter = (filter) => {
    //var filter = document.getElementById('filter').value;
    setSelectedTypeFilter(filter);
    setLoading(true);
    post("admin/candidates/1/search/1", { q: filter, language: selectedLanguageFilter, type: "filter" })
      .then(async function (response) {
        setLoading(false);
        setCandidates(response.data.data);
        setTotalRows(response.data.totalRows);
        setCandidateTypeCounts(response.data.countByCandidateType);
        setPending(false);

        var table = window.$("#datatableRows").DataTable();
        table.destroy();

        setTimeout(function () {
          var uninitialized = window.$("#datatableRows").filter(function () {
            return !window.$.fn.DataTable.fnIsDataTable(this);
          });

          uninitialized.each(function () {
            window.$(this).dataTable({
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excel",
                  text: "Export Excel",
                  className: "btn btn-light",
                  exportOptions: {
                    columns: "th:not(:last-child)",
                  },
                },
                {
                  extend: "csv",
                  text: "Export Csv",
                  className: "btn btn-light",
                  exportOptions: {
                    columns: "th:not(:last-child)",
                  },
                },
              ],
            });
          });
        }, 100);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const filterByType = (type) => {
    
    setCandidateType(type);
    filterByDate(type, 1);
  };

  const filterCandidate = () => {
    filterByDate(candidateType, 1);
  }

  const filterByDate = (candidateType, page) => {
    var date_from = document.getElementById("start_date").value;
    var date_to = document.getElementById("end_date").value;
    var candidateLanguage = document.getElementById("language_level").value;
    setLoading(true);

    post("admin/candidates/1/search/" + page, {
      date_from: date_from,
      date_to: date_to,
      type: "date",
      candidate_type: candidateType,
      candidate_status: 1,
      language: candidateLanguage,
    })
      .then(async function (response) {
        setLoading(false);
        setCandidates(response.data.data);
        setTotalRows(response.data.totalRows);
        setCandidateTypeCounts(response.data.countByCandidateType);
        setPending(false);

        var table = window.$("#datatableRows").DataTable();
        table.destroy();

        setTimeout(function () {
          var uninitialized = window.$("#datatableRows").filter(function () {
            return !window.$.fn.DataTable.fnIsDataTable(this);
          });

          uninitialized.each(function () {
            window.$(this).dataTable({
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excel",
                  text: "Export Excel",
                  className: "btn btn-light",
                  exportOptions: {
                    columns: "th:not(:last-child)",
                  },
                },
                {
                  extend: "csv",
                  text: "Export Csv",
                  className: "btn btn-light",
                  exportOptions: {
                    columns: "th:not(:last-child)",
                  },
                },
              ],
            });
          });
        }, 100);

      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const changeStatus = (candidateId, status) => {
    setLoading(true);
    post("admin/candidates/status_change", {
      candidate_id: candidateId,
      status: status,
    })
      .then(async function (response) {
        _loadCandidates();
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
      });
  };

  const _filterByLang = (e) => {
    setSelectedLanguageFilter(e.target.value);
    setLoading(true);
    post("admin/candidates/1/search/1", {
      q: selectedTypeFilter,
      language: e.target.value,
      type: "lang",
    })
      .then(async function (response) {
        setLoading(false);
        setCandidates(response.data.data);
        setTotalRows(response.data.totalRows);
        setPending(false);

        if (window.$.fn.DataTable.isDataTable('#datatableRows')) {
          window.$('#datatableRows').DataTable().destroy();
        }

        var table = window.$("#datatableRows").DataTable({
          fixedColumns: {
            left: 1,
            right: 1,
          },
        });
        table.destroy();

        setTimeout(function () {

          var uninitialized = window.$("#datatableRows").filter(function () {
            return !window.$.fn.DataTable.fnIsDataTable(this);
          });

          uninitialized.each(function () {
            window.$(this).dataTable({
              dom: "Bfrtip",
              fixedColumns: {
                left: 1,
                right: 1,
              },
              buttons: [
                {
                  extend: "excel",
                  text: "Export Excel",
                  className: "btn btn-light",
                  exportOptions: {
                    columns: "th:not(:last-child)",
                  },
                },
                {
                  extend: "csv",
                  text: "Export Csv",
                  className: "btn btn-light",
                  exportOptions: {
                    columns: "th:not(:last-child)",
                  },
                },
              ],
            });
          });
        }, 100);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const _markAsReadyRecruit = (candidateId) => {
    setLoading(true);
    post("admin/candidates/ready_to_recruit", {
      candidate_id: candidateId,
    })
      .then(async function (response) {
        _loadCandidates(1);
        setLoading(false);

        success({
          title: "SUCCESS",
          text: "Successfully added to ready to recruit list",
          modules: new Map([
            [
              Confirm,
              {
                confirm: true,
                buttons: [
                  {
                    text: "Ok",
                    primary: true,
                    click: (notice) => {
                      notice.close();
                    },
                  },
                ],
              },
            ],
          ]),
        });
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
      });
  }

  const _recommended = (candidateId) => {
    setLoading(true);
    post("admin/candidates/recommended", {
      candidate_id: candidateId,
    })
      .then(async function (response) {
        _loadCandidates(1);
        setLoading(false);

        success({
          title: "SUCCESS",
          text: "Successfully added to recommended list",
          modules: new Map([
            [
              Confirm,
              {
                confirm: true,
                buttons: [
                  {
                    text: "Ok",
                    primary: true,
                    click: (notice) => {
                      notice.close();
                    },
                  },
                ],
              },
            ],
          ]),
        });
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error);
      });
  };

  var documentStatus = {
    0: "Pending",
    1: "Submitted",
    2: "Waiting Proposal",
    3: "Waiting Payment",
    4: "Translation Progress",
    5: "Translation Under Review",
    6: "Completed",
  };

  const columnsD = [
    {
      name: "Title",
      selector: (row) => row.title,
    },
    {
      name: "Year",
      selector: (row) => row.year,
    },
  ];

  const data = [
    {
      id: 1,
      title: "Beetlejuice",
      year: "1988",
    },
    {
      id: 2,
      title: "Ghostbusters",
      year: "1984",
    },
  ];

  function replaceString(str) {
    if (str == undefined) {
      return "";
    }

    return str.replace("_", " ");
  }

  const _del = (id) => {
    if (window.confirm("Are you sure you want to delete?") == true) {
      setLoading(true);
      post("admin/candidates/delete", {
        candidate_id: id,
      })
        .then(async function (response) {
          _loadCandidates(1);
          setLoading(false);

          success({
            title: "SUCCESS",
            text: "Successfully deleted",
            modules: new Map([
              [
                Confirm,
                {
                  confirm: true,
                  buttons: [
                    {
                      text: "Ok",
                      primary: true,
                      click: (notice) => {
                        notice.close();
                      },
                    },
                  ],
                },
              ],
            ]),
          });
        })
        .catch(function (error) {
          setLoading(false);
          console.log(error);
        });
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setToastMessage(text + " copied to clipboard!");
        setToastType("success");
      })
      .catch((err) => {
        console.error("Could not copy text: ", err);
        setToastMessage("Failed to copy " + text + " to clipboard");
        setToastType("error");
      });
  };

  const closeToast = () => {
    setToastMessage(null);
  };

  return (
    <>
      <Header />
      <Loader loading={loading} />

      <main>
        <div class="container-fluid">
          <div class="row">
            {/* Menu Start */}
            <SideBar />
            {/*  Menu End */}

            {/* Page Content Start */}
            <div class="col">
              {/* Title and Top Buttons Start */}
              <div class="page-title-container mt-3 mb-5">
                <div class="row g-0">
                  <div class="col-auto mb-2 mb-md-0 me-auto">
                    <div class="w-auto">
                      <h1 class="mb-0 pb-0 card-title" id="title">
                        Process Not Started Candidates
                      </h1>
                    </div>
                  </div>
                  <div class="w-100 d-md-none"></div>
                  <div class="col-12 col-sm-6 col-md d-flex align-items-start justify-content-end order-3 order-sm-2">
                    <div class="w-100 w-lg-auto search-input-container border border-separator">
                      <input
                        class="form-control search"
                        type="text"
                        autocomplete="off"
                        placeholder="Search"
                      />
                      <span class="search-magnifier-icon">
                        <i data-acorn-icon="search"></i>
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-auto d-flex align-items-start justify-content-end mb-2 mb-sm-0 order-sm-3">
                    <div
                      class="dropdown-as-select d-inline-block"
                      data-childSelector="span"
                    >
                      <button
                        class="btn p-0"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span
                          class="btn btn-outline-primary dropdown-toggle"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-delay="0"
                          title="Candidate filter"
                        ></span>
                      </button>
                      <div class="dropdown-menu dropdown-menu-end">
                        <a
                          class="dropdown-item active"
                          href="javascript:;"
                          onClick={() => filter("")}
                        >
                          Filter By
                        </a>
                        {/* <a
                          class="dropdown-item"
                          href="javascript:;"
                          onClick={() => filter("licensed")}
                        >
                          Registered Nurses
                        </a>
                        <a
                          class="dropdown-item"
                          href="javascript:;"
                          onClick={() => filter("non-licensed")}
                        >
                          Nurses
                        </a>
                        <a
                          class="dropdown-item"
                          href="javascript:;"
                          onClick={() => filter("students")}
                        >
                          Students
                        </a>
                        <a
                          class="dropdown-item"
                          href="javascript:;"
                          onClick={() => filter("other")}
                        >
                          Others
                        </a> */}
                        <a
                          class="dropdown-item"
                          href="javascript:;"
                          onClick={() => filter("KDA Brochure")}
                        >
                          KDA Brochure Readers
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Title and Top Buttons End */}

              {/*FILTER
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-sm-4'>
                                            <div class="input-group">
                                                <input id="q" placeholder="Enter Name/Email/Phone" type="text" class="form-control" aria-label="Text input with segmented dropdown button" />
                                                <button type="button" class="btn btn-outline-primary" onClick={() => search()}>
                                                    <i data-acorn-icon="search" class="icon" data-acorn-size="18"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div className='col-sm-2'>
                                            <div class="dropdown-as-select d-inline-block" data-childSelector="span">
                                                <button class="btn p-0" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <span
                                                        class="btn btn-outline-primary dropdown-toggle"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        data-bs-delay="0"
                                                        title="Item Count"
                                                    ></span>
                                                </button>
                                                <div class="dropdown-menu dropdown-menu-end">
                                                    <a class="dropdown-item active" href="javascript:;" onClick={() => filter('')}>Filter By</a>
                                                    <a class="dropdown-item" href="javascript:;" onClick={() => filter('licensed')}>Licensed</a>
                                                    <a class="dropdown-item" href="javascript:;" onClick={() => filter('non-licensed')}>Non-Licensed</a>
                                                    <a class="dropdown-item" href="javascript:;" onClick={() => filter('students')}>Students</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-sm-6'>
                                            <div class="input-daterange input-group" id="datePickerRange">
                                                <input type="text" class="form-control" name="start" id="start_date" placeholder="Start Date" />
                                                <span class="mx-2"></span>
                                                <input type="text" class="form-control" name="end" id="end_date" placeholder="End Date" />
                                                <span class="mx-2"></span>
                                                <button type="button" class="btn btn-outline-primary mb-1" onClick={() => filterByDate()}>Search</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-sm-12'>
                                            <DataTable
                                                columns={columns}
                                                data={candidates}
                                                defaultSortFieldId={1}
                                                fixedHeader
                                                responsive={true}
                                                striped={true}
                                                highlightOnHover={true}
                                                progressPending={pending}
                                                pagination
                                                paginationServer={true}
                                                paginationPerPage={paginationPerPage}
                                                paginationTotalRows={totalRows}
                                                onChangePage={pagination}
                                            />
    </div>
                                    </div>
                                </div>
    </div>*/}

              <div className="row mt-5">
                <div className="col-sm-2" onClick={() => filterByType('all')} style={{}}>
                  <div class="card mb-5 hover-border-primary" style={{height: '7rem',border: candidateType == 'all' ? '1px solid #0ad1f7' : '' }}>
                    <div class="h-100 p-4 text-center align-items-center d-flex flex-column justify-content-between">
                      {/* <div class="d-flex flex-column justify-content-center align-items-center sh-5 sw-5 rounded-xl bg-gradient-light mb-2">
                        <i data-acorn-icon="alarm" class="text-white"></i>
                      </div> */}
                      <p class="mb-0 lh-1">All</p>
                      <p class="cta-3 mb-0 text-primary">{totalRows}</p>
                    </div>
                  </div>
                </div>
                {Object.entries(candidateTypeCounts).map(
                      ([type, count]) => {
                        if (
                          type === null ||
                          type === undefined ||
                          type === "null"
                        ) {
                          return null;
                        }
                        if (count !== null && count !== undefined) {
                          return (

                            <div className="col-sm-2" onClick={() => filterByType(type)}>
                              <div class="card mb-5 hover-border-primary" style={{height: '7rem',border: candidateType == type ? '1px solid #0ad1f7' : '' }}>
                                <div class="h-100 p-4 text-center align-items-center d-flex flex-column justify-content-between">
                                  {/* <div class="d-flex flex-column justify-content-center align-items-center sh-5 sw-5 rounded-xl bg-gradient-light mb-2">
                                    <i data-acorn-icon="alarm" class="text-white"></i>
                                  </div> */}
                                  <p class="mb-0 lh-1">{replaceString(type)}</p>
                                  <p class="cta-3 mb-0 text-primary">{count}</p>
                                </div>
                              </div>
                            </div>
                          );
                        }
                        return null;
                      }
                )}
              </div>

              {/* <div className="card mb-3">
                <div className="card-body">
                  <h5 className="card-title">Count by candidate type</h5>
                  <div className="d-flex justify-content-between">
                    {Object.entries(candidateTypeCounts).map(
                      ([type, count]) => {
                        if (
                          type === null ||
                          type === undefined ||
                          type === "null"
                        ) {
                          return null;
                        }
                        if (count !== null && count !== undefined) {
                          return (
                            <div key={type}>
                              <strong>{replaceString(type)}:</strong> {count}
                            </div>
                          );
                        }
                        return null;
                      }
                    )}
                  </div>
                </div>
              </div> */}

              <div class="card mb-5 p0" style={{ padding: 0 }}>
                <div class="card-body p0" style={{ padding: 10 }}>

                  <div className="row">
                    <div className="col-sm-3">
                      <label class="form-label">Date From:</label>
                      <input type="date" class="form-control" name="start" id="start_date" placeholder="Date From" />
                    </div>
                    <div className="col-sm-3">
                      <label class="form-label">Date To:</label>
                      <input type="date" class="form-control" name="end" id="end_date" placeholder="Date To" />
                    </div>
                    <div className="col-sm-3">
                      <label class="form-label">Language Level:</label>
                      <select class="form-select" id="language_level">
                        {languageLevelsId.map((l, k) => (
                          <option value={l.id} key={k}>{l.val}</option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-3">
                        <label class="form-label">&nbsp;</label>
                        <button type="button" class="btn btn-outline-primary mt-4" onClick={() => filterCandidate()}>Filter</button>
                    </div>
                  </div>

                  {/* {languageLevelsId.map((l, k) => (
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        id={l.id}
                        value={l.id}
                        name="filter"
                        checked={selectedLanguageFilter === l.id}
                        onChange={(e) =>
                          _filterByLang(e)
                        }
                      />
                      <label class="form-check-label" for={l.id}>
                        {l.val}
                      </label>
                    </div>
                  ))} */}
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div class="card-header">
                  <div className="row">
                    <div className="col-sm-6">
                      <label className="form-label" id="title">Search</label>
                      <input type="text" id="q" className="form-control" placeholder="Enter Name/Email/Phone" onKeyPress={(e) => { if (e.key === 'Enter') search(); }} />
                    </div> 
                    <div className="col-sm-3">
                      <button type="button" class="btn btn-outline-primary mt-4 me-3" onClick={() => search()}>Search</button>
                      <button type="button" class="btn btn-outline-secondary mt-4" onClick={() => filterReset()}>Reset</button>
                      {selectedRows.length > 0 && (
                        <button
                          type="button"
                          class="btn btn-danger mt-4 ms-3"
                          onClick={batchDelete}
                        >
                          Delete Selected
                        </button>
                      )}
                    </div> 
                  </div>
                </div>
                    <div className="card-body">

                        <DataTable
                          keyField="candidate_id"
                          columns={columns}
                          data={candidates}
                          defaultSortFieldId={1}
                          fixedHeader
                          responsive={true}
                          striped={true}
                          highlightOnHover={true}
                          progressPending={pending}
                          pagination
                          paginationServer={true}
                          paginationPerPage={paginationPerPage}
                          paginationTotalRows={totalRows}
                          onChangePage={pagination}
                          expandableRows
                          expandableRowsComponent={ExpandedComponent}
                          paginationRowsPerPageOptions={[]}
                        />
                      </div>
                  </div>
                </div>
              </div>

              
              {toastMessage && (
                <Toast
                  message={toastMessage}
                  type={toastType}
                  onClose={closeToast}
                />
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />

      {assignStaffModal && (
        <div className="modal fade show" style={{ display: "block" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Assign Staff</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setAssignStaffModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <select
                  className="form-select"
                  value={selectedStaffId}
                  onChange={(e) => setSelectedStaffId(e.target.value)}
                >
                  <option value="">Select Staff</option>
                  {staffs.map((staff) => (
                    <option key={staff._id} value={staff._id}>{staff.staff_name}</option>
                  ))}
                </select>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setAssignStaffModal(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => assignStaff()}
                >
                  Assign
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default withParams(ActiveCandidates);
